import { render, staticRenderFns } from "./processDiffer.vue?vue&type=template&id=23ea50e4&scoped=true"
import script from "./processDiffer.vue?vue&type=script&lang=js"
export * from "./processDiffer.vue?vue&type=script&lang=js"
import style0 from "./processDiffer.vue?vue&type=style&index=0&id=23ea50e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea50e4",
  null
  
)

export default component.exports